export var getDocumentType = function (value) {
    if (!value)
        return undefined;
    value = value.replace(/\D/g, '');
    if (value.length === 11)
        return 'CPF';
    if (value.length === 14)
        return 'CNPJ';
    return undefined;
};
